import * as React from "react";

export const PlayButton: React.SFC<{}> = props => (
  <svg width={30} height={30} viewBox="0 0 120 100">
    <polygon points="20,0 120,50 20,100" style={{ fill: "#333" }} />
  </svg>
);
